<template>
  <div>
    <div>
      <Button type="primary" @click="handleEdit">编辑</Button>
    </div>

    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>

    <Modal
      v-model="modalVisibile"
      width="543"
      :mask-closable="false"
      title="编辑会员"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        inline
        label-position="top"
      >
      <div v-for="(item,index) in jsonParam" :key="index">
         <FormItem :label="item.vip_name">
            <Input @on-change="startLevelChange(index)" v-model.trim="item.start_number" :disabled="true" style="width:80px;"></Input>
        </FormItem>
        <FormItem :label="index!=jsonParam.length-1?'< 总计 <=':''" :label-width="80" style="margin-top:34px;margin-left:-20px;"></FormItem>
         <FormItem label="" :label-width="0" v-if="index!=jsonParam.length-1" style="margin-top:26px;">
            <Input @on-change="endLevelChange(index)" v-model.trim="item.end_number" style="width:80px;"></Input>
        </FormItem>
         <FormItem label="折扣:" :class="index==jsonParam.length-1?'lastInput1':'lastInput'" >
            <Input v-model.trim="item.discount" style="width:80px;"></Input>
        </FormItem>
      </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from '@/mixins/page'
export default {
  name: 'user_manage',
  mixins: [mixins],
  data () {
    const validatePhome = (rule, value, callback) => {
      if (isNaN(value - 0)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      isAdmin: Number(localStorage.getItem('sa')),
      modalVisibile: false,
      modalLoading: false,
      isShowEnd: true,
      formData: {},
      formData1: {},
      modalForm: {},
      tableData: [],
      jsonParam: [],
      modalRule: {
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          { validator: validatePhome, trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '会员名称',
          key: 'vip_name',
          align: 'center'
        },
        {
          title: '金额',
          key: 'money',
          align: 'center',
          render: (h, params) => {
            if (params.row.end_number) {
              return h('span', params.row.start_number + '<总计<=' + params.row.end_number)
            } else {
              return h('span', params.row.start_number + '<总计')
            }
          }
        },
        {
          title: '折扣',
          key: 'discount',
          align: 'center'
        }
        // {
        //   title: "操作",
        //   width: 150,
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "span",
        //         {
        //           class: {
        //             btn_edit: true
        //           },
        //           on: {
        //             click: () => this.handleEdit(params)
        //           }
        //         },
        //         "编辑"
        //       )
        //     ]);
        //   }
        // }
      ]
    }
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    startLevelChange (index) {
      this.jsonParam = this.jsonParam.map((v, i) => {
        if (i > index) {
          v.start_number = ''
          v.end_number = ''
        } else {
          v.end_number = ''
        }
        return v
      })
    },
    endLevelChange (index) {
      this.jsonParam = this.jsonParam.map((v, i) => {
        if (i > index) {
          v.start_number = ''
          v.end_number = ''
        }
        if (i - 1 == index) {
          v.start_number = this.jsonParam[i - 1].end_number
        }
        return v
      })
    },
    handleReset () {
      this.formData = Object.assign({}, this.formData1)
      this.handleQuery()
    },
    handleCancel () {
      this.$refs.modalForm.resetFields()
      this.modalVisibile = false
    },
    // 编辑
    handleEdit (params) {
      this.modalVisibile = true
      // this.modalForm.discount = params.row.discount;
      // this.modalForm.start_number = params.row.start_number;
      // this.modalForm.end_number = params.row.end_number;
      // this.modalForm.vip_name = params.row.vip_name;
      // this.modalForm.id = params.row.id;
      // this.modalForm.status = params.row.status;

      // if(params.row.status===5){
      //   this.isShowEnd=false
      // }else{
      //   this.isShowEnd=true
      // }
    },
    handleModalSubmit () {
      //  if(!this.modalForm.discount||!this.modalForm.start_number){
      //     this.$Message.warning ('请检查信息是否完整');
      //     return
      // }
      // this.modalForm.discount = Number(this.modalForm.discount);
      // this.modalForm.start_number = Number(this.modalForm.start_number);
      // this.modalForm.end_number = Number(this.modalForm.end_number);
      // this.modalForm.status = Number(this.modalForm.status);
      let validte = true
      this.jsonParam.forEach((v, i) => {
        if (v.end_number && (Number(v.end_number) <= Number(v.start_number))) {
          validte = false
        }
      })
      if (!validte) {
        this.$Message.warning('请检查会员等级的结束值是否大于开始值')
        return
      }

      this.modalLoading = true

      this.$api.memberEdit({ json_param: this.jsonParam }).then(res => {
        if (res.code == 0) {
          this.handleQuery()
          this.handleCancel()
        } else {
          this.$Message.error(res.data)
        }
        this.modalLoading = false
      })
    },
    handleQuery () {
      this.page_num = 1
      this.getTableData()
    },
    getTableData () {
      this.tableLoading = true
      this.$api
        .memberList({ page_num: this.page_num, page_size: this.page_size })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data
            this.jsonParam = JSON.parse(JSON.stringify(res.data))
          } else {
            this.$Message.error(res.msg)
          }
          this.tableLoading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ivu-modal-body {
  padding-bottom: 0;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input{
  color: #515a6e;
}
.lastInput{
  margin-left: 40px;
}
.lastInput1{
  margin-left: 128px;
}
/deep/ivu-form-item-content{
  margin-left:0 !important;
}
</style>
